export default __webpack_public_path__ + "static/media/resume_empty_box_icon.b0a068b5.svg";